import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { HtmlText } from '../molcules/HtmlText';
var useStyles = makeStyles(function (theme) { return ({
    couponName: function (props) { return ({
        padding: theme.spacing(1),
        color: props.couponNameTextColor,
        backgroundColor: props.couponNameBandColor,
        textAlign: 'center',
    }); },
}); });
/**
 * クーポン名。HTMLが入っている場合はそちらを優先して表示する。
 */
export var CouponName = function (props) {
    var classes = useStyles(props);
    return (React.createElement(Box, { className: classes.couponName }, props.couponNameHtml ? (React.createElement(HtmlText, { text: props.couponNameHtml })) : (React.createElement(Typography, { variant: 'h6' }, props.couponName))));
};
//# sourceMappingURL=CouponName.js.map